var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsingOurPortalArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.506,
    height: 55.357,
    viewBox: "0 0 86.506 55.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98873",
    "data-name": "Group 98873",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, -1.161, 6.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M8.286,0l8.286,14.583H0Z",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 73.18, 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10239",
    "data-name": "Path 10239",
    d: "M10.15,33.84A99.1,99.1,0,0,1-.7,33.308a1.549,1.549,0,0,1-1.294-1.736A1.494,1.494,0,0,1-.367,30.188a105.239,105.239,0,0,0,14.307.451,97.094,97.094,0,0,0,13.6-1.363,62.027,62.027,0,0,0,14.068-4.091,57.877,57.877,0,0,0,12.2-7.415A82.717,82.717,0,0,0,63.32,9.026a84.849,84.849,0,0,0,8.35-10.352,1.409,1.409,0,0,1,2.043-.393A1.639,1.639,0,0,1,74.082.465,86.137,86.137,0,0,1,65.443,11.2a85.809,85.809,0,0,1-9.869,9.086A60.79,60.79,0,0,1,42.725,28.09a64.833,64.833,0,0,1-14.733,4.289,99.934,99.934,0,0,1-14.012,1.4C12.639,33.822,11.357,33.84,10.15,33.84Z",
    transform: "translate(2 15.326)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsingOurPortalArrow);
export default __webpack_public_path__ + "static/media/using-our-portal-arrow.48f4fe35698afe56b93294f8db0223ae.svg";
export { ForwardRef as ReactComponent };